import React from 'react';

interface ClientProps {
  className?: string;
  width?: number;
  height?: number;
}

const ClientIcon = function ClientIcon({
  className,
  width,
  height,
}: ClientProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <ellipse cx="16" cy="10.0013" rx="8" ry="7.33333" fill="#28364C" />
      <path d="M5.47876 22.5688C6.493 20.0426 9.07407 18.668 11.7962 18.668H20.2038C22.9259 18.668 25.507 20.0426 26.5212 22.5688C27.1868 24.2265 27.8041 26.2554 27.9615 28.3356C28.0031 28.8863 27.5523 29.3346 27 29.3346H5C4.44772 29.3346 3.99687 28.8863 4.03853 28.3356C4.19591 26.2554 4.8132 24.2265 5.47876 22.5688Z" fill="#28364C" />
      <path d="M15.8884 21.2774L13.7124 20.1894C13.618 20.1423 13.6516 20 13.7571 20H18.2432C18.3487 20 18.3823 20.1423 18.2879 20.1894L16.112 21.2774C16.0416 21.3126 15.9587 21.3126 15.8884 21.2774Z" fill="white" stroke="white" strokeWidth="0.5" />
      <path d="M15.9998 21.3333L18.6116 27.8629C18.6379 27.9285 18.5895 28 18.5188 28L13.4809 28C13.4101 28 13.3618 27.9285 13.388 27.8629L15.9998 21.3333Z" fill="white" stroke="white" strokeWidth="0.5" />
    </svg>
  );
};

ClientIcon.defaultProps = {
  className: '',
  width: 32,
  height: 32,
};

export default ClientIcon;
